import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import lazyWithReload from 'utils/lazy-with-reload'
import { Layout } from 'app/layout/Layout'

const RefurbishmentHome = lazyWithReload(() => import(/* webpackPrefetch: true */ 'app/refurbishment/components/RefurbishmentContainer'))
const TestingDieselParts = lazyWithReload(() => import(/* webpackPrefetch: true */ 'app/refurbishment/components/TestingDieselParts'))
const CleaningTheParticulateFilter = lazyWithReload(
  () => import(/* webpackPrefetch: true */ 'app/refurbishment/components/CleaningTheParticulateFilter')
)

export const RefurbishmentContainer: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layout title={t('Dashboard.Refurbishments')}>
      <Switch>
        <Route exact path='/forms' component={RefurbishmentHome} />
        <Route path='/forms/testingdieselparts/:TemplateUUID' render={props => <TestingDieselParts {...(props as any)} />} />
        <Route
          path='/forms/cleaningtheparticulatefilter/:TemplateUUID'
          render={props => <CleaningTheParticulateFilter {...(props as any)} />}
        />
        <Redirect to='/404' />
      </Switch>
    </Layout>
  )
}

RefurbishmentContainer.displayName = 'RefurbishmentContainer'

export default RefurbishmentContainer
